import Vue from "vue";

export class Upload {
    /**
     *
     * @param data
     * @return {Promise}
     */
    static post(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contrato/kmz", data)
                .then(res => resolve(), err => reject(err));
        });
    }
}
